module.exports = __webpack_public_path__ + "static/media/footerlogo1.fba97176.png";